export const getHighlightSlug = () => {
  const slugs = window.location.pathname.split('/');
  return slugs[3];
};
